import { RoofPitch as RestorationRoofPitch } from '@eigtech/restoration-types'
import { RoofPitch as TarpulatorRoofPitch } from '@eigtech/tarpulator-types'
import { exhaustive } from 'exhaustive'

export const getRoofPitchLabel = (roofPitch: RestorationRoofPitch | TarpulatorRoofPitch) =>
  exhaustive(roofPitch, {
    '07_12AndUnder': () => 'Under 7/12',
    '07_12To09_12': () => '7/12 to 9/12',
    '10_12To12_12': () => '10/12 to 12/12',
    over12_12: () => 'Over 12/12',
  })
